<template>
  <form style="position: relative">
    <div style="position:absolute; top: 10px; right: 10px;">
    <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>Dyn {{ $t('Add.Container.Container') }} Block</h2>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
      <div class="divider">
        <label class="contentLabel" for="node">Dynamic node</label>
          <input
          type="text"
          id="node"
          v-model="sharedData.data.props.dynamicNode"
          @keydown.enter.prevent="addClassName"
          placeholder="Enter node"
          />
    </div>  
    <NameProp :sharedData="sharedData" />
    <ClassNamesProp :sharedData="sharedData" />
    <div class="class-names">
      <span v-for="(name, index) in classNames" :key="index" class="class-pill">
        {{ name }}
        <span class="material-symbols-outlined class-remove" @click="removeClassName(index)">close</span>
      </span>
    </div>
    </div>
    </div>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Style') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('style')" class="accordion-content">
    <div class="divider">
      <label class="contentLabel" for="width">{{ $t('Add.Container.Width') }}</label>
      <div class="range-container">
        <input type="range" min="1" max="500" v-model="width" class="slider" id="width" />
        <span>{{ width }} 
          <span 
          v-if="sharedData?.data?.style?.width && 
          sharedData?.data?.style?.width !== 'inherit'">px</span></span>
        <span v-if="sharedData?.data?.style?.width && 
        sharedData?.data?.style?.width !== 'inherit'" 
        class="material-symbols-outlined reset-color refresh" 
          @click="resetWidth">refresh</span>
      </div>
    </div>
    <div class="divider">
      <label class="contentLabel" for="height">{{ $t('Add.Container.Height') }}t</label>
      <div class="range-container">
        <input type="range" min="1" max="400" v-model="height" class="slider" id="height" />
        <span>{{ height }} 
          <span v-if="sharedData?.data?.style?.height &&
          sharedData?.data?.style?.height !== 'auto'">px</span></span>
        <span v-if="sharedData?.data?.style?.height &&
        sharedData?.data?.style?.height !== 'auto'" 
        class="material-symbols-outlined reset-color refresh" 
          @click="resetHeight">refresh</span> 
        </div>
      </div>
    <BackgroundColorProp :sharedData="sharedData" />
    <div class="divider">
      <label class="contentLabel" for="borderColor">{{ $t('Add.Container.BorderColor') }}</label>
      <div class="color-container">
        <input type="color" id="borderColor" v-model="borderColor" />
        <span v-if="borderColor" class="material-symbols-outlined reset-color" @click="resetBorderColor">close</span>
        <div v-else class="add-color-overlay">+</div>
      </div>
    </div>
    <div class="divider">
      <label class="contentLabel" for="borderWidth">{{ $t('Add.Container.BorderWidth') }}</label>
      <div class="range-container">
        <input type="range" min="1" max="20" v-model="borderWidth" class="slider" id="borderWidth" />
        <span>{{ borderWidth }} px</span>
      </div>
    </div>
    <div class="divider">
      <label class="contentLabel" for="borderRadius">{{ $t('Add.Container.BorderRadius') }}</label>
      <div class="range-container">
        <input type="range" min="1" max="100" v-model="borderRadius" class="slider" id="borderRadius" />
        <span>{{ borderRadius }} px</span>
      </div>
    </div>
    <div v-if="isParentRoot && false" class="divider">
      <p>Position</p>
      <div class="input-container">
        <label>
          <input type="radio" class="radios" name="textAlign" value="absolute" v-model="position" />
          <span class="radioSelect firstSelect">Absolute</span>
        </label>
        <label class="last">
          <input type="radio" class="radios" name="textAlign" value="static" v-model="position" />
          <span class="radioSelect lastSelect">Static</span>
        </label>
      </div>
    </div>
    </div>
    </div>
    <!-- Reiter: Positioning -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('positioning')" class="accordion-content">
      <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
  </form>
</template>

<script>
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import BackgroundColorProp from './AddProps/BackgroundColorProp.vue';
import { mapGetters } from 'vuex';
import CopyBlock from './AddProps/CopyBlock.vue';
export default {
  name: 'AddDynContainer',
  components: {
    NameProp,
    ClassNamesProp,
    PaddingProp,
    BackgroundColorProp,
    CopyBlock,
  },
  props: ['sharedData'],
  data(){
    return {
      activeSections: ['main'], // Default aktivierter Reiter
      newClassName: '',
    }
  },
  computed: {
    ...mapGetters(['getEmailData']),
    height: {
      get() {
        return this.sharedData?.data?.style?.height || 'auto';
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.height = value;
      },
    },
    width: {
      get() {
        return this.sharedData?.data?.style?.width || 'inherit';
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.width = value;
      },
    },
    borderColor: {
      get() {
        return this.sharedData?.data?.style?.borderColor || null;
      },
      set(value) {
        if (!this.sharedData.data.style) this.sharedData.data.style = {};
        this.sharedData.data.style.borderColor = value;
      },
    },
    borderWidth: {
      get() {
        return this.sharedData?.data?.style?.borderWidth || 1;
      },
      set(value) {
        if (!this.sharedData.data.style) this.sharedData.data.style = {};
        this.sharedData.data.style.borderWidth = value;
      },
    },
    borderRadius: {
      get() {
        return this.sharedData?.data?.style?.borderRadius || 0;
      },
      set(value) {
        if (!this.sharedData.data.style) this.sharedData.data.style = {};
        this.sharedData.data.style.borderRadius = value;
      },
    },
    position: {
      get() {
        return this.sharedData?.data?.style?.position || 'static';
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.position = value;
      },
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
  isParentRoot(){
      const emailData = this.getEmailData
      console.log(emailData.root.data.childrenIds.indexOf(this.sharedData.id) > -1)
      console.log(this.sharedData)
 /*     if (emailData.root.data.childrenIds.indexOf(this.sharedData.id) > -1) {
        return true
      } else {
        return false
      } */
      return emailData.root.data.childrenIds.indexOf(this.sharedData.id) > -1
    },
    
  },
  methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
        this.activeSections = this.activeSections.filter(s => s !== section);
      } else {
        // Abschnitt hinzufügen
        this.activeSections.push(section);
      }
      this.$store.dispatch('addClass', trimmedName);
    },
    isSectionActive(section) {
      return this.activeSections.includes(section);
    },
    resetHeight() {
      this.sharedData.data.style.height = 'auto';
    },
    resetWidth() {
      this.sharedData.data.style.width = 'inherit';
    },
  }
};
</script>


 <style scoped>
@import '../../styles/addComponents.css';

.refresh {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 25px;
  margin-right: 10px;
}
</style>